
import { Vue, Component, Prop } from "vue-property-decorator";

import { seenatlasService } from "../service";
import { SACharakteristik } from "../interfaces";

import Gallery, { ResourceMeta } from "@/components/Gallery.vue";

@Component({ components: { Gallery } })
export default class Charakteristik extends Vue {
  @Prop()
  id!: string;

  charakteristik: SACharakteristik | null = null;

  beforeMount() {
    this.getCharakteristik(this.id);
  }

  imageResourceMeta: ResourceMeta = {
    application: "seenatlas",
    resource: "foto",
    id: this.id
  };

  getCharakteristik(id: string) {
    seenatlasService
      .getSACharakteristik(id)
      .then(response => {
        this.charakteristik = response.data[0];
      })
      .catch(e => {
        console.error(e);
      });
  }
}
